import api from "@/api/axios";
import { API } from "@/App";
import { useEffect, useState } from "react";

export function useProjects() {
  const [projects, setProjects] = useState([]);
  useEffect(() => { api.get(`${API}/projects`).then(r => setProjects(r.data)).catch(() => setProjects([])); }, []);
  return projects;
}